export default "__VITE_ASSET__CjFvVWcO__"